/**
 * @file Blog.jsx
 * @description Blog page
 */

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import HeroImage from '../new_images/pexels-kampus-8636589.jpg';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'The Future of Data for Social Impact',
      excerpt: 'Exploring how data analytics can drive meaningful change in the social sector.',
      date: 'January 15, 2024',
      category: 'Data Analytics',
    },
    {
      id: 2,
      title: 'Building Sustainable M&E Systems',
      excerpt: 'Best practices for creating monitoring and evaluation frameworks that organizations actually use.',
      date: 'January 10, 2024',
      category: 'M&E',
    },
    {
      id: 3,
      title: 'Responsible AI in Development',
      excerpt: 'How to implement AI solutions that are ethical, transparent, and truly helpful.',
      date: 'January 5, 2024',
      category: 'AI & Automation',
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Blog | Bellefy Insights</title>
        <meta
          name="description"
          content="Read insights and articles from Bellefy Insights on data analytics, M&E, and social impact."
        />
      </Helmet>

      {/* Hero Section */}
      <section 
        id="intro" 
        style={{ 
          paddingTop: '150px', 
          paddingBottom: '100px', 
          minHeight: 'auto',
          backgroundImage: `linear-gradient(111deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${HeroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundAttachment: 'fixed'
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h1 className="text-center" style={{ color: '#ffffff', marginBottom: '1rem' }}>
                Blog
              </h1>
              <p className="text-center lead" style={{ color: '#ffffff' }}>
                Insights on Data, Analytics, and Social Impact
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Blog Posts */}
      <section className="section-bg">
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h2 className="cormorant-garamond text-center mb-5">Latest Articles</h2>
              
              <Row>
                {blogPosts.map((post) => (
                  <Col md={4} key={post.id} className="mb-4">
                    <div
                      style={{
                        backgroundColor: '#ffffff',
                        padding: '24px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#ed7b0b',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          marginBottom: '12px',
                        }}
                      >
                        {post.category}
                      </div>
                      <h4 style={{ marginBottom: '12px', fontSize: '20px' }}>
                        {post.title}
                      </h4>
                      <p style={{ color: '#666', marginBottom: '16px', flex: 1 }}>
                        {post.excerpt}
                      </p>
                      <div
                        style={{
                          fontSize: '14px',
                          color: '#999',
                          borderTop: '1px solid #eee',
                          paddingTop: '12px',
                        }}
                      >
                        {post.date}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>

              <div className="text-center mt-5">
                <p>More articles coming soon!</p>
                <p>
                  Subscribe to our newsletter to stay updated on new posts.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Blog;
